import React, { useState, useEffect } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import axios from 'axios'
import configData from './../config.json'
import { useEffectX } from 'use-effect-x'
import { useTranslation } from 'react-i18next'
import { Loader } from 'rsuite'
import ProductIntendedMaterials from './product/intended-materials'
import ShowSimilarProducts from './product/similar'
import ReactHtmlParser from 'react-html-parser'
import MaterialsLegend from './product/materials-legend'

import FilesFromCategory from './files-from-category'

const SingleProductPage = () => {

  const { id } = useParams()
  
  const history = useHistory()

  const [ loading, setLoading ] = useState(true)

  const [ product, setProduct ] = useState(null)
  const [ intendedMaterials, setIntendedMaterials ] = useState(null)
  const [ category, setCategory ] = useState(null)
  const [ purpose, setPurpose ] = useState(null)

  const { i18n, t } = useTranslation()
  const lang = i18n.language
  

  useEffectX(
    ({changedItem: [productObj]}) => {
      if (productObj.isFirstRun) {
        // get product data
        axios.get(`${configData['REST_URL']}/wp/v2/products/${id}`)
          .then(data => setProduct(data.data))     
        // get availables materials     
        axios.get(`${configData['REST_URL']}/wp/v2/intended_material`)
        .then(data => setIntendedMaterials(data.data))
      }
      // when products loaded get category and purpose
      if (productObj.changed && productObj.previous === null && productObj.next !== null) {
        axios.get(`${configData['REST_URL']}/wp/v2/purpose/${productObj.next.purpose}`)
          .then(data => setPurpose(data.data))
        axios.get(`${configData['REST_URL']}/wp/v2/category/${productObj.next.category}`)
          .then(data => setCategory(data.data))
      }
    }, [product]
  )

  if (loading && product !== null && category !== null && purpose !== null && intendedMaterials !== null) {
    setLoading(false)
  }

  const renderContent = () => {
    const contentToParse = product.content.rendered.replaceAll('<div id="filesFromCategory"></div>', '<FilesFromCategory/>')
    const content = ReactHtmlParser(contentToParse, {
      decodeEntities: true,
      transform
    })
    const translatedContent = content.filter(el => {
      return el.props.id === lang
    })[0]
    return translatedContent
  }

  function transform(node) {
    if (node.type === 'tag' && node.name === 'filesfromcategory') {
      return (<FilesFromCategory category={category.id}/>)
    }
  }

  const handleContentClick = (e) => {
    e.preventDefault()

    if (e.target.matches('a, a *')) {
      const link = e.target.closest('a')      
      if (link.getAttribute('href').startsWith('#uagb-tabs__tab')){        
        e.preventDefault()        
        const uagbTabsContent = document.querySelectorAll('.uagb-tabs__body')
        const uagbTabsSwitches = document.querySelectorAll('.uagb-tab')
        uagbTabsSwitches.forEach(tab => {
          tab.classList.remove('active')
        })
        uagbTabsContent.forEach(tab => {
          if (`#${tab.getAttribute('aria-labelledby')}` === link.getAttribute('href')) {
            tab.classList.add('active')
          } else {
            tab.classList.remove('active')
          }
        })
        link.closest('.uagb-tab').classList.add('active')
      }
    }
  }

  // open first tab
  useEffect(() => {
    const uagbSwitches = document.querySelectorAll('.uagb-tab')
    if (uagbSwitches.length > 0) {
      uagbSwitches[0].querySelector('a').click()
    }
  })

  return (
    <div className="page page-single-product">
      <div className="content">        
        <div className="back-section">
          <div 
            className="button" 
            id="goBack"
            onClick={() => history.push('/products/', history.location.state)}
            >
            <span >&laquo;</span> {t("Go back")}
          </div>
        </div>
        {loading ? (
          <div className="loading">
            <Loader size="lg" content={t("Loading...")} vertical/>          
          </div>
        ) : (
          <>
            <div className="single-product-data">
              <div className="data-wrapper">
                <div className="image">
                  <img src={product.acf.extra.img} alt="" />
                </div>
                <div className="data">
                  <h2 className="name">
                    {product.acf.names[`name_${lang}`]}
                  </h2>
                  <div className="purpose">
                    {purpose?.acf.names[`name_${lang}`]} 
                  </div>
                  <div className="diameter">
                    φ {product.acf.extra.diameter}
                  </div>
                  {product.acf.intended && (
                    <>
                    <ProductIntendedMaterials 
                      intendedMaterials={intendedMaterials}
                      productMaterials={product.acf.intended}
                      productConditionalMaterials={product.acf.intended_conditional}
                    />
                    <MaterialsLegend/>
                    </>
                  )}
                </div>
              </div>
              <div className="category-sketch">
                <img src={category.acf.sketch} alt="" />
              </div>
            </div>
            {/* <ShowSimilarProducts category={category} /> */}
            <div className="single-product-content" onClick={handleContentClick}>
              {renderContent()}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default SingleProductPage
